import styled from 'styled-components';

const GradeTitle = styled.h2`
    font-size: 1.2rem;
    margin-top: 2rem;
`;

// eslint-disable-next-line import/prefer-default-export
export { GradeTitle };
